'use client'

import { Common } from '@/config/NextImport'

const InfoBoxSection = () => {
  return (
    <section className="section info-box-section">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6 col-lg-4 info-box-col">
            <div className="info-box-repeat text-center">
              <img
                src={Common.setImagePath('assets/images/info-icon1.png')}
                className="info-box-img"
                alt="Free Shipping"
                loading="lazy"
              />

              <div className="info-box-content">
                <h6 className="info-box-title">Free Shipping</h6>
                <p>Complementary & Fully insured UK shipping.</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 info-box-col">
            <div className="info-box-repeat text-center">
              <img
                src={Common.setImagePath('assets/images/info-icon4.png')}
                className="info-box-img"
                alt="Gift Package"
                loading="lazy"
              />

              <div className="info-box-content">
                <h6 className="info-box-title">Gift Package</h6>
                <p>We&apos;ll choose the perfect gift box for your present.</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 info-box-col">
            <div className="info-box-repeat text-center">
              <img
                src={Common.setImagePath('assets/images/info-icon2.png')}
                className="info-box-img"
                alt="Customer Service"
                loading="lazy"
              />
              <div className="info-box-content">
                <h6 className="info-box-title">Customer Service</h6>
                <p>Our consultants will help you to choose the right size.</p>
              </div>
            </div>
          </div>
          {/* <div className="col-md-6 col-lg-3 info-box-col">
               <div className="info-box-repeat text-center">
                 <img src={process.env.PUBLIC_URL + '/assets/images/info-icon.jpg'} className="info-box-img" alt="Free Engraving" />
                 <div className="info-box-content">
                   <h6 className="info-box-title">Free Engraving </h6>
                   <p>Individual engraving to perpetuate the deepest feelings.</p>
                 </div>
                </div>
               </div> */}
        </div>
      </div>
    </section>
  )
}

export default InfoBoxSection
